import React, { useState, useContext } from 'react';
import { Modal } from './Modal';
import AuthContext from '../../context/auth/authContext';
import FeedbackContext from '../../context/feedback/feedbackContext';
import './FeedbackModal.css';

const FeedbackModal = ({ isOpen, onClose }) => {
  const authContext = useContext(AuthContext);
  const feedbackContext = useContext(FeedbackContext);
  const { user } = authContext;
  const { addFeedback } = feedbackContext;

  const [formData, setFormData] = useState({
    type: 'feedback',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { type, message } = formData;

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getMessageInfo = () => {
    switch (type) {
      case 'feedback':
        return 'Please provide any feedback for your experience on PokeMatch thus far, we are constantly working to improve this tool for you. The Community.';
      case 'suggestion':
        return 'Please describe any and all features, functionality or improvements you think would make this tool better for yourself and the community! We are open to everything and want to make this a tool everyone can use!';
      case 'bug':
        return 'Please describe the bug you are experiencing or have experience as well as 1 or 2 steps to recreate it so that it can be fixed promptly. Thank you for your continued support!';
      default:
        return '';
    }
  };

  const handleSubmit = async () => {
    if (!message.trim()) {
      alert('Please enter a message');
      return;
    }

    try {
      setIsSubmitting(true);
      
      // Submit feedback using the context
      await addFeedback({
        type,
        message
      });
      
      // Reset form
      setFormData({ type: 'feedback', message: '' });
      
      // Close modal
      onClose();
      
      // Show success message
      alert('Thank you for your submission! You can view your submissions in the Support page.');
    } catch (error) {
      console.error('Error submitting feedback:', error);
      alert('Failed to submit. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      title={`Submit ${type.charAt(0).toUpperCase() + type.slice(1)}`}
      primaryButtonText={isSubmitting ? "Submitting..." : "Submit"}
      primaryButtonAction={handleSubmit}
      secondaryButtonText="Cancel"
    >
      <div className="feedback-form">
        <div className="form-group">
          <label htmlFor="type" className="form-label">Type of Submission</label>
          <select
            id="type"
            name="type"
            className="form-control"
            value={type}
            onChange={handleChange}
            disabled={isSubmitting}
          >
            <option value="feedback">Feedback</option>
            <option value="suggestion">Suggestion</option>
            <option value="bug">Bug Report</option>
          </select>
        </div>
        
        <div>
          <div className="message-info">{getMessageInfo()}</div>
          <textarea
            name="message"
            className="form-control"
            value={message}
            onChange={handleChange}
            placeholder="Enter your message..."
            rows={6}
            required
            disabled={isSubmitting}
          />
        </div>
      </div>
    </Modal>
  );
};

// Floating feedback button component
export const FeedbackButton = ({ onClick }) => {
  return (
    <button className="feedback-button" onClick={onClick} title="Send Feedback">
      <i className="fas fa-comment-alt"></i>
    </button>
  );
};

export default FeedbackModal;